import { AiRequestMetadataInput } from "@/modules/patients/detail/referral/services/ch/__generated__/chReferralLetterCopilotQuery.graphql"
import { chReferralLetterCopilotQuery } from "@/modules/patients/detail/referral/services/ch/chReferralLetterCopilotQuery"
import { deReferralLetterCopilotQuery } from "@/modules/patients/detail/referral/services/de/deReferralLetterCopilotQuery"
import { Country } from "@/types/__generated__/union-types"

export type { AiRequestMetadataInput } from "@/modules/patients/detail/referral/services/ch/__generated__/chReferralLetterCopilotQuery.graphql"

export const referralLetterCopilotQuery = (country: Country, aiRequestMetadata: AiRequestMetadataInput) => {
  if (country === "DE") {
    return deReferralLetterCopilotQuery(aiRequestMetadata)
  }
  return chReferralLetterCopilotQuery(aiRequestMetadata)
}
